<template>
  <button class="u-calc-button u-calc-button--save" @click="showEmailModal">
    <p>Email Your Savings</p>
    <span></span>
  </button>
</template>
<script>
import { mapFields } from "vuex-map-fields";

export default {
  created() {},
  components: {},
  mounted() {},
  computed: {
    ...mapFields(["submission.email", "viewContent.EmailModal"]),
  },
  methods: {
    showEmailModal() {
      this.$modal.show(
        {
          template: `
            <div class="c-modal">
              <button class="c-modal__close" @click="$emit('close')">×</button>
              <div class="c-modal__inner">
    
                <div v-if="!emailStatus.sent">
                  <p class="c-modal__title">
                    {{title}}
                  </p>
                  <div v-html="modalContent"></div>
                  <input type="email" v-model="email" />
                  <p class="c-modal__error" v-if="displayEmailError">Please add a valid Email Address</p>
                  <div>
                    <button class="u-calc-button u-calc-button--save" @click="checkEmail"><p>Send Email</p><span></span></button>
                  </div>
                </div>

                <div v-if="emailStatus.sent">
                  <p v-if="!emailStatus.error" class="c-modal__title">Thanks, email sent!</p>
                  <p v-if="emailStatus.error" class="c-modal__title">Sorry, an error has occured</p>
                  <button class="u-calc-button" @click="$emit('close')"><p>Close</p><span></span></button>
                </div>

              </div>
            </div>
          `,
          data: () => ({
            displayEmailError: false,
          }),
          props: ["title", "modalContent", "sendEmailEvent"],
          computed: {
            ...mapFields(["submission.email", "config.emailStatus"]),
          },
          methods: {
            checkEmail() {
              //full email validation
              const emailRegex =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

              if (emailRegex.test(this.email)) {
                this.displayEmailError = false;
                this.sendEmailEvent();
              } else {
                this.displayEmailError = true;
              }
            },
          },
        },
        {
          title: "Email Your Savings",
          modalContent: this.EmailModal.EmailModalContent,
          sendEmailEvent: this.sendEmail,
        },
        { height: "auto", adaptive: true, scrollable: true }
      );
    },
    hideEmailModal() {
      this.$modal.hide();
    },
    sendEmail(e) {
      this.$store
        .dispatch("sendEmail")
        .then((res) => {
          console.log("successfully sent");
        })
        .catch((error) => {
          console.log("show error state");
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss">
.c-modal {
  position: relative;
  border: 2px solid #000000;
  //   @media all and (min-width: $md) {
  //     padding: 30px;
  //   }

  p {
    margin-bottom: 20px;
  }

  input {
    border: 2px solid black;
    margin-bottom: 7px;
  }

  .u-calc-button--save {
    margin-right: 5px;
  }

  .c-modal__inner {
    padding: 45px 55px;
    border: 10px solid #04b776;
  }

  .c-modal__title {
    margin-bottom: 20px;
    font-size: 18px;
    font-family: "Lato";
    font-weight: 600;
  }

  .c-modal__close {
    position: absolute;
    right: 10px;
    top: 5px;
    cursor: pointer;
    font-size: 32px;
    color: #000000;
    -webkit-tap-highlight-color: transparent;
    width: auto;
    border: none;
    background: none;
    padding: 8px 14px;

    &:hover {
      color: #707070;
    }
  }

  .c-modal__button {
    border-radius: 50px;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
    color: white;
    cursor: pointer;
    display: block;
    padding: 0 25px;
    text-align: center;
    text-decoration: none;
    transition: all ease-in-out 0.2s;
    margin: 0 auto;

    // @media all and (min-width: $md) {
    //   padding: 5px 30px;
    //   margin: 0 auto;
    // }

    &:hover {
      box-shadow: 0 0.5em 0.5em -0.4em rgba(0, 0, 0, 0.3);
      transform: translateY(-2px);
    }
  }
}

p.c-modal__error {
  color: red;
  font-size: 12px;
  margin: 0px;
}

//overwrite bugfix
.vm--modal {
  height: auto !important;
}
</style>
